import type { RouteResources } from '@atlassian/react-resource-router';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { legacyGinBulkeditRoute } from '@jira/router-routes__legacy-gin-bulkedit-routes/src/legacyGinBulkeditRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyGinBulkeditRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	legacyGinBulkeditRoute,
	() => ({
		layout: globalLayout,
		entryPoint: () => pageEntryPoint,
	}),
);
